import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { useDragLayer } from 'react-dnd';
import { getItemStyles } from './utils';

export interface ListDragLayerProps {
  title: string;
}

export const ListDragLayer: FC<ListDragLayerProps> = ({ title }) => {
  const {
    isDragging,
    initialCursorOffset,
    initialOffset,
    currentOffset,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialCursorOffset: monitor.getInitialClientOffset(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging) {
    return null;
  }

  return (
    <Box
      position="fixed"
      pointerEvents="none"
      zIndex={100}
      top={0}
      left={0}
      width="full"
      height="full"
    >
      <div
        style={getItemStyles(initialCursorOffset, initialOffset, currentOffset)}
      >
        <Box
          data-testid="drag-layer-tooltip"
          bg="black"
          color="white"
          p={2}
          borderRadius={4}
          lineHeight="17px"
          boxShadow="elevated"
        >
          {title}
        </Box>
      </div>
    </Box>
  );
};
